import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Button } from '@lacedltd/laced-components'

export const BackButton = styled(Button)({
  display: 'flex',
  margin: `${tokens.spacing[5]} ${tokens.spacing[6]}`,
  padding: 0,
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: tokens.spacing[5],
  alignSelf: 'stretch',
  textDecoration: 'none',
  textTransform: 'none',
  width: 'fit-content',

  '&:hover': { background: 'transparent' },

  span: { margin: 0 }
})

export const ContentSection = styled.div({
  padding: `0 0 ${tokens.spacing[10]} 0`
})

export const Section = styled.div({
  '& + &': {
    marginTop: tokens.spacing[3],
    paddingTop: tokens.spacing[3],
    borderTop: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[100]}`
  }
})

export const SectionLabel = styled.div({
  padding: `${tokens.spacing[2]} ${tokens.spacing[6]} ${tokens.spacing[2]} ${tokens.spacing[9]}`,
  fontSize: '0.625rem',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: tokens.color.airJordan[400]
})

export const NavLink = styled.a({
  display: 'flex',
  alignItems: 'center',
  gap: tokens.spacing[3],
  padding: `${tokens.spacing[3]} ${tokens.spacing[6]} ${tokens.spacing[3]} ${tokens.spacing[9]}`,
  fontSize: '0.8125rem',
  lineHeight: 1.4,
  color: tokens.color.airJordan[500],
  textDecoration: 'none',
  borderLeft: '2px solid transparent',
  transition:
    'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease',

  '&:hover': {
    backgroundColor: tokens.color.airJordan[50],
    textDecoration: 'none',
    color: tokens.color.airJordan[700]
  },

  '&[data-active="true"]': {
    color: tokens.color.airJordan[800],
    borderLeftColor: tokens.color.airJordan[800],
    backgroundColor: tokens.color.airJordan[100],
    fontWeight: 500
  }
})

export const NotificationDot = styled.span({
  flexShrink: 0,
  width: 5,
  height: 5,
  borderRadius: '50%',
  backgroundColor: tokens.color.roshe[400],

  '[data-active="true"] &': {
    backgroundColor: tokens.color.roshe[500]
  }
})
